// SSEComponent.tsx
import {useEffect, useRef} from 'react';
import {useSnapshot} from 'valtio';
import {sseStore} from '@/utils/store/store';
import {ERROR_MESSAGES} from '@/constants/messages';
import {checkAllParam, handleError} from '@/utils/helpers';
import {fetchEventSource} from '@microsoft/fetch-event-source';
import { useSupabaseAuth } from '@/utils/store/supabaseAuth';
import { saveHistoryAndEvaluation } from '@/services/historyService';

type SSEProps = {
  url: string;
};




const SSEComponent = ({ url }: SSEProps) => {
  const { params, requestId } = useSnapshot(sseStore);
  const { id, user, isAuthenticated, isLoading } = useSupabaseAuth();

  // 初始化为当前 requestId，重新挂载时不会误判为"新请求"
  const processedRef = useRef(sseStore.requestId);

  useEffect(() => {
    // 只有 requestId 变化且与已处理的不同时才触发
    if (!requestId || requestId === processedRef.current) {
      return;
    }

    let isLegal = checkAllParam(sseStore.params,"Industry","Content","Output_type");

    if (!isLegal) {
      sseStore.loading = false;
      console.error("必填项为空，请补充");
      return;
    }

    if (sseStore.loading) {
      console.log("is loading, return");
      return;
    }

    // 标记已处理
    processedRef.current = requestId;

    const controller = new AbortController();

    // 当 params 变化时触发请求
    const fetchData = async () => {
      try {
        sseStore.loading = true;
        sseStore.error = null;

        await fetchEventSource(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // 'Authorization': key
          },
          body: JSON.stringify({
            // app_id: "7451101746413862953",
            parameters:sseStore.params,
            // workflow_id:"7451275515125039123"
          }), // 使用全局存储的参数
          signal: controller.signal,
          onopen: async (response) => {
            if (!response.ok) {
              // debug
              sseStore.trace = sseStore.trace
                + "SSE failed" + JSON.stringify(response) + "\n";
              throw new Error(`SSE failed: ${response.status}`);
            }
          },
          openWhenHidden: true, // 保持后台连接
          onmessage: (event) => {
            try {
              // debug
              sseStore.trace = sseStore.trace + JSON.stringify(event) + "\n";


              // concat data
              if(JSON.parse(event.data)['content']){
                console.log(41,JSON.parse(event.data))
                let content = JSON.parse(event.data)['content'];

                // 删除扣子出现的空字符串对
                content =  content.replace(/\{\}/g, '')
                sseStore.data = sseStore.data + content;
              }
            } catch (err) {
              handleError(err, ERROR_MESSAGES.NETWORK_ERROR);
            throw new Error('SSE data parse error');
            }
          },
          onerror: (err) => {
            // debug
            sseStore.trace = sseStore.trace
              + "SSE Error" + JSON.stringify(err) + "\n";
            handleError(err, ERROR_MESSAGES.NETWORK_ERROR);
            throw err instanceof Error ? err : new Error('SSE error');
          }
        });
      } catch (err) {
        sseStore.error = err instanceof Error ? err : new Error('Unknown error');
      } finally {
        sseStore.trace = sseStore.trace
          + "SSE finish" + "\n";
        sseStore.loading = false;

        // 如果登录了，保存历史
        if(isAuthenticated && !isLoading && id){
          await saveHistoryAndEvaluation({
            userId: id,
            email: user?.email,
            result: sseStore.data,
            input: params,
          });
        }

      }
    };

    fetchData();

    return () => {
      controller.abort();
      sseStore.loading = false;
    };
  }, [url, requestId]); // requestId 非空时触发，消费后清空

  return null;
};

export default SSEComponent;